module.exports = __webpack_public_path__ + "static/media/new-svgrepo-com.c94627cc.svg";